var _path, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.76926 0.76923C5.76926 0.344396 5.42486 0 5.00003 0C4.57519 0 4.23079 0.344396 4.23079 0.769231V4.23077H0.76923C0.344396 4.23077 0 4.57517 0 5C0 5.42484 0.344396 5.76924 0.769231 5.76924H4.23079V9.23077C4.23079 9.6556 4.57519 10 5.00003 10C5.42486 10 5.76926 9.6556 5.76926 9.23077V5.76924H9.23077C9.6556 5.76924 10 5.42484 10 5C10 4.57517 9.6556 4.23077 9.23077 4.23077H5.76926V0.76923Z",
    fill: "url(#paint0_linear_1_4912)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4912",
    x1: 0,
    y1: 0,
    x2: 10.2267,
    y2: 0.237463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC2B6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC00A9"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddButton);
export default __webpack_public_path__ + "static/media/AddButton.d46a4d1f959361300e1fed6cd6d9501e.svg";
export { ForwardRef as ReactComponent };